/** Aggregated theme object consumed via useTheme(). */
import { ColorScheme, DarkColors, LightColors } from './colors';
import { FontFamily, FontSize, FontWeight, LetterSpacing, LineHeight } from './typography';
import { Spacing } from './spacing';
import { Radii } from './radii';
import { Motion } from './motion';
import { shadow } from './shadows';

export interface Theme {
  isDark: boolean;
  colors: ColorScheme;
  font: typeof FontFamily;
  fontSize: typeof FontSize;
  fontWeight: typeof FontWeight;
  lineHeight: typeof LineHeight;
  letterSpacing: typeof LetterSpacing;
  spacing: typeof Spacing;
  radii: typeof Radii;
  motion: typeof Motion;
  shadow: (name: 'sm' | 'base' | 'md' | 'lg' | 'focus') => ReturnType<typeof shadow>;
}

export function buildTheme(isDark: boolean): Theme {
  return {
    isDark,
    colors: isDark ? DarkColors : LightColors,
    font: FontFamily,
    fontSize: FontSize,
    fontWeight: FontWeight,
    lineHeight: LineHeight,
    letterSpacing: LetterSpacing,
    spacing: Spacing,
    radii: Radii,
    motion: Motion,
    shadow: (name) => shadow(name, isDark),
  };
}

export const lightTheme = buildTheme(false);
export const darkTheme = buildTheme(true);
